<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-19 14:01:51
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 16:47:58
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-19 13:48:06
 * @LastEditors: lau
 * @LastEditTime: 2022-08-19 13:49:55
-->
<!-- 获取车辆欠费记录 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
            },
            responseCode: 	{
                "data": {
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询运营商欠费记录",
                t_url: this.commonUrls.test+"getArrearsListByOperator",
                p_url: this.commonUrls.prod+"getArrearsListByOperator",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                    { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '每页多少条，最多100条' },
                     
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '否', info3: 'Integer', info4: '记录总数' },
                        { info1: 'data', info2: '是', info3: 'JSONArray', info4: '记录列表' },
                        { info1: 'page', info2: '是', info3: 'Integer', info4: '页' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条' },

                        ]
                }
                ,{
                    titleName: 'data',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        { info1: 'arrearsOrigin', info2: '是', info3: 'Integer', info4: '欠费标记来源' },
                        { info1: 'arrearsStatus', info2: '是', info3: 'Integer', info4: '0正常欠费，1取消欠费' },
                        { info1: 'arrearsValue', info2: '是', info3: 'Decimal', info4: '补缴实交金额' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'enterCarCodeColor', info2: '是', info3: 'Integer', info4: '进场车牌颜色' },
                        { info1: 'enterTime', info2: '是', info3: 'Date', info4: '进场时间' },
                        { info1: 'id', info2: '是', info3: 'Long', info4: '欠费记录id' },
                        { info1: 'isBackPay', info2: '是', info3: 'Integer', info4: '是否已补缴（0否，1是）' },
                        { info1: 'leaveCarCodeColor', info2: '是', info3: 'Integer', info4: '离场车牌颜色' },
                        { info1: 'leaveTime', info2: '是', info3: 'Date', info4: '离场时间' },
                        { info1: 'paidValue', info2: '是', info3: 'Decimal', info4: '已收实交金额' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkUuid', info2: '是', info3: 'String', info4: '停车场uuid' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
                        { info1: 'shouldValue', info2: '是', info3: 'Decimal', info4: '当前欠费金额' },
                        { info1: 'topBillCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'totalValue', info2: '是', info3: 'Decimal', info4: '停车费用总金额' },
                        { info1: 'operator', info2: '否', info3: 'String', info4: '操作人' },
            
                        ]
                }
            ],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/record/getArrearsListByOperator.vue